export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  sort: {
    key: 'createDate',
    order: -1,
  },
  filter: {
    status: '',
    _id: '',
    externalId: '',
    email: '',
    website: '',
    companyName: '',
    country: '',
    createDate: {
      from: '',
      to: '',
    },
    isEmailConfirmed: '',
    isUsingSdk: '',
  },
  accountApps: {
    showModal: false,
    apps: [],
  },
  isFetching: false,
  fetchingErrorMessage: '',
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/accounts.state.js
 **/